import { Button, Card, Form, FormInstance, Row } from "antd";
import TextArea from "antd/es/input/TextArea";
import { SendOutlined } from "@ant-design/icons";
import { useCallback, useMemo, useState } from "react";
import { UploadAttachment } from "./UploadAttachment";

type InputMessageProps = {
  form: FormInstance;
  isSending: boolean;
  send: () => void;
};

export const InputMessage = ({ form, isSending, send }: InputMessageProps) => {
  const [hasFile, setHasFile] = useState<boolean>(false);

  const [focused, setFocused] = useState<boolean>(false);

  const toggleFocused = useCallback(
    (): void => setFocused((prev: boolean) => !prev),
    []
  );

  const cardClassName = useMemo(
    () => `w-100 ${focused ? "focused" : ""}`,
    [focused]
  );

  const [isUploading, setIsUploading] = useState<boolean>(false);

  const text: string = Form.useWatch("text", form);

  const attachment: string = Form.useWatch("attachment", form);

  const isSendDisabled: boolean = useMemo(() => {
    if (isUploading || isSending) {
      return true;
    } else {
      return attachment ? false : !text || text.length === 0;
    }
  }, [text, attachment, isUploading, isSending]);

  const autoSizeCinfig: any = useMemo(() => ({ minRows: 2, maxRows: 3 }), []);

  return (
    <Form form={form} className="w-100">
      <Row className="w-100 input-message-container">
        <Card className={cardClassName}>
          <Form.Item name="text">
            <TextArea
              autoSize={autoSizeCinfig}
              placeholder="Write a message"
              onFocus={toggleFocused}
              onBlur={toggleFocused}
              className="text"
            />
          </Form.Item>

          <Row className="position-relative">
            {hasFile && <Row className="w-100 attachment__container" />}

            <Row className="w-100 justify-space-between align-end">
              <UploadAttachment
                setIsUploading={setIsUploading}
                setHasFile={setHasFile}
              />

              <Button
                disabled={isSendDisabled}
                shape="round"
                type="primary"
                size="large"
                icon={<SendOutlined className="text-sm" />}
                loading={isSending}
                onClick={send}
              >
                Send
              </Button>
            </Row>
          </Row>
        </Card>
      </Row>
    </Form>
  );
};
